import React from 'react';
import { IntlShape } from 'react-intl';
import { observer } from 'mobx-react';
import { IRegistrationType } from '../../../../../../../../api/registration-configuration.dao';
import { FormField } from '../../../../../../../global/form/form-field/form-field';
import GeneralRegistrationVM from '../general-registration.viewmodel';
import GeneralRegistrationSettingsItem from './general-registration-settings-item';
import './general-registration-settings.scss';

interface IGeneralRegistrationSettings {
    vm: GeneralRegistrationVM;
    intl: IntlShape;
    registrationType: IRegistrationType[];
}

const GeneralRegistrationSettings = observer(({
    vm,
    intl,
    registrationType,
}: IGeneralRegistrationSettings) => {

    return (
        <div
            className='m-top-40px m-bottom-25px'
        >
            <FormField
                label={intl.formatMessage({
                    defaultMessage: 'Settings for Each Triage Answer',
                    id: 'oe.triageQuestion.settingsForEachTriageAnswer',
                    description: 'Label text'
                })}
                className='general-settings-title'
            >
            </FormField>
            {vm.settingsFormNames.map(triageAnswer=> (
                <GeneralRegistrationSettingsItem
                    key={triageAnswer}
                    registrationType={registrationType}
                    setting={vm.settings.find(s => s.formName === vm.getFormNameByDisplayName(triageAnswer))}
                    triageAnswer={triageAnswer}
                    intl={intl}
                    vm={vm}
                />
            ))}
        </div>
    );
});

export default GeneralRegistrationSettings;
